import React from "react";

const HERO_BG = "/mnt/data/Screenshot 2025-11-15 210257.png";

export default function HeroCard21() {
  return (
    <>
      <header className="hwf-hero">
        {/* background image + dark overlay */}
        <div className="hwf-bg" role="img" aria-label="hero background" />
        <div className="hwf-overlay" />

        <div className="hwf-inner">
          {/* left content */}
          <div className="hwf-left">
            <div className="hwf-vertical-accent" aria-hidden />
            <div className="hwf-eyebrow">PUBLISHING HOUSE</div>

            <h1 className="hwf-title">
              THE NEW NOVEL <span>FROM JOHN</span> <br />
              VERMA
            </h1>

            <p className="hwf-lead">
              Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
              tempor incididunt ut labore et dolore magna aliqua.
            </p>

            <div className="hwf-ctas">
              <button className="hwf-btn hwf-btn-primary">READ MORE</button>
              <button className="hwf-btn hwf-btn-outline">CONTACT US</button>
            </div>
          </div>

          {/* right image */}
          <div className="hwf-right">
              {/* Footer contact card + logos */}
        <div className="hwf-contact-left">
            <h3>For Any Help or Queries Please Contact Us</h3>
            <div className="hwf-contact-items">
              <div className="item">
                <strong>+01234667890</strong>
                <small>Phone</small>
              </div>
              <div className="item">
                <strong>info@business.com</strong>
                <small>Email</small>
              </div>   {/* decorative dot-hc21s */}
            <div className="hwf-dot-hc21s" aria-hidden>
              <span className="dot-hc21 active" />
              <span className="dot-hc21" />
              <span className="dot-hc21" />
            </div>
            </div>
          </div>

         
          </div>
       
        </div>
      </header>

     

      <style>{`
/* ------------------- HERO ------------------- */
.hwf-hero {
  position: relative;
  min-height: 72vh;
  display:block;
  overflow: hidden;
  padding: 36px 6%;
  background: #0b0b0c;
  color: #fff;
}

/* background image sits behind overlay */
.hwf-bg {
  position: absolute;
  inset: 0;
  background-image: url('${HERO_BG}');
  background-size: cover;
  background-position: center right;
  filter: brightness(0.6);
  z-index: 1;
}
.hwf-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, rgba(8,8,8,0.82) 0%, rgba(8,8,8,0.35) 55%, rgba(8,8,8,0.75) 100%);
  z-index: 2;
}

/* hero inner content */
.hwf-inner {
  position: relative;
  z-index: 3;
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 24px;
  justify-content: space-between;
}

/* LEFT */
.hwf-left {
  width: 54%;
  max-width: 760px;
  position: relative;
  padding-left: 12px;
}

/* vertical accent line */
.hwf-vertical-accent {
  position: absolute;
  left: -18px;
  top: 20px;
  width: 6px;
  height: 280px;
  background: linear-gradient(to bottom, #2f6bff, #2f6bff);
  border-radius: 4px;
  box-shadow: 0 0 0 2px rgba(47,107,255,0.04);
}

/* eyebrow */
.hwf-eyebrow {
  color: #cfcfd0;
  font-weight: 700;
  letter-spacing: 1px;
  margin-bottom: 18px;
}

/* Title */
.hwf-title {
  font-size: 3.6rem;
  font-weight: 800;
  line-height: 1.02;
  margin: 6px 0 18px;
  color: #fff;
}
.hwf-title span { color: #ffffff; opacity: 0.95; }

/* Lead */
.hwf-lead {
  color: #d0d0d2;
  max-width: 650px;
  margin-bottom: 28px;
  line-height: 1.6;
  font-size: 1.02rem;
}

/* CTA Buttons */
.hwf-ctas { display:flex; gap: 16px; align-items:center; }
.hwf-btn {
  padding: 12px 26px;
  border-radius: 30px;
  font-weight: 700;
  cursor: pointer;
  border: none;
}
.hwf-btn-primary {
  background: #2f6bff;
  color: #fff;
  box-shadow: 0 8px 30px rgba(47,107,255,0.12);
}
.hwf-btn-outline {
  background: transparent;
  color: #fff;
  border: 2px solid rgba(255,255,255,0.12);
}

/* RIGHT image area */
.hwf-right {
  width: 36%;
  display:flex;
  align-items:center;
  justify-content:flex-end;
  position:relative;
}

.hwf-hero-img {
  width: 420px;
  max-width: 100%;
  border-radius: 6px;
  object-fit: cover;
  filter: brightness(0.98);
  transform: translateX(10px);
  box-shadow: 0 20px 60px rgba(2,6,12,0.55);
}

/* dot-hc21s decorative */
.hwf-dot-hc21s {
  position:absolute;
  right: 36px;
  top: 46%;
  transform: translateY(-50%);
  display:flex;
  flex-direction:column;
  gap:10px;
}
.hwf-dot-hc21s .dot-hc21 {
  width:10px; height:10px; border-radius:50%;
  background: rgba(255,255,255,0.25);
  border: 2px solid rgba(255,255,255,0.08);
}
.hwf-dot-hc21s .dot-hc21.active { background:#2f6bff; box-shadow: 0 6px 18px rgba(47,107,255,0.2); }

/* subtle slide-in (CSS only) */
@keyframes hwfSlideUp {
  from { opacity: 0; transform: translateY(14px); }
  to { opacity: 1; transform: translateY(0); }
}
.hwf-left, .hwf-right { animation: hwfSlideUp 900ms ease both; }

/* ------------------- FOOTER CONTACT CARD ------------------- */
.hwf-footer {
  margin-top: -6px;
  position: relative;
  z-index: 4;
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
}

/* contact card with blue angled left */
.hwf-contact-card {
  background: transparent;
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap: 22px;
  max-width: 1400px;
  margin: 0 auto;
  transform: translateY(-20%);
  padding: 24px;
  position: relative;
}

/* angled blue left block */
.hwf-contact-left {
  background: linear-gradient(135deg, #2f6bff 0%, #2b63ff 100%);
  color: #fff;
  padding: 28px 34px;
  border-radius: 6px;
  min-width: 420px;
  clip-path: polygon(10% 0, 100% 0, 100% 100%, 0% 100%);
  box-shadow: 0 20px 40px rgba(47,107,255,0.12);
}
.hwf-contact-left h3 {
  margin: 0 0 10px;
  font-size: 1.2rem;
  font-weight: 800;
}
.hwf-contact-items { display:flex; gap:18px; margin-top: 8px; }
.hwf-contact-items .item { color: rgba(255,255,255,0.95); }
.hwf-contact-items .item strong { display:block; font-size:1rem; font-weight:700; }
.hwf-contact-items .item small { opacity:0.88; }

/* right side of contact card */
.hwf-contact-right {
  display:flex;
  flex-direction:column;
  align-items:flex-end;
  gap:14px;
  min-width: 420px;
}
.hwf-trusted small { color: #111; background:#fff; padding:6px 10px; border-radius:4px; font-weight:700; }

/* logos row */
.hwf-logos {
  display:flex;
  gap: 18px;
  margin-top: 6px;
  align-items:center;
}
.hwf-logos .logo {
  width:56px; height:32px;
  background: rgba(255,255,255,0.08);
  display:grid; place-items:center;
  color:#fff; border-radius:6px; font-weight:700;
}



/* ------------------- RESPONSIVE ------------------- */
@media (max-width: 1100px) {
  .hwf-inner { flex-direction: column-reverse; gap: 28px; }
  .hwf-left { width: 100%; text-align: center; padding-left: 0; }
  .hwf-right { width: 100%; justify-content: center; }
  .hwf-hero-img { width: 68%; transform: translateX(0); }
  .hwf-contact-card { transform: translateY(-10%); padding:18px; flex-direction:column; align-items:stretch; gap:12px; }
  .hwf-contact-left, .hwf-contact-right { min-width: auto; width:100%; text-align:center; align-items:center; }
  .hwf-contact-right { align-items:center; }
  .hwf-logos-bar-inner { flex-direction:column; gap:12px; text-align:center; }
  .hwf-logos { justify-content:center; }
}
@media (max-width: 560px) {
  .hwf-title { font-size: 2rem; }
  .hwf-vertical-accent { display:none; }
  .hwf-contact-left { padding:18px; }
  .hwf-mini-thumb { display:none; }
}
      `}</style>
    </>
  );
}
